import './App.css';
import Navbar from './componets/Navbar/Navbar.jsx'
import Home from './componets/Home/Home.jsx';
import Footer from './componets/Footer/Footer.jsx';
import { BrowserRouter , Route, Routes, } from 'react-router-dom';
import Login from './Login/Login.js';
import Registration from "./componets/Registration/Registration.js";

function App() {
  return (
    <div className="App overflow-hidden ">

      <BrowserRouter>
      <Navbar/>
      <Routes>
        <Route path='/Registration' element={<Registration/>} />
        <Route path="/Login" element={<Login />} />
        <Route path='/' element={<Home/>} />
         </Routes>
      <Footer/>
        </BrowserRouter>
    </div>
  );
}

export default App;
